<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div>
    <!-- Leon -->
    <div v-show="showLeon()" class="sreen">
      <div class="back"></div>
      <div class="leon">
        <img src="https://cdn.exploreve.fr/content/personnages/leon.svg" />
      </div>
      <div class="bulle" style="top: 10vh; left: 36vw;">
        <p class="text">
          {{ text[currentStep] }}
        </p>
      </div>
      <div class="next-button" style="bottom: 5vh; right: 5vw;" v-on:click="validStep">
        {{ buttonText[currentStep] }}
      </div>
    </div>

    <!-- Explication 1  -->
    <b-modal
      size="xl"
      ref="modal"
      header-bg-variant="light"
      body-bg-variant="light"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <template v-slot:modal-header><h3>Se repérer en ballon-songe</h3></template>
      <div class="d-flex justify-content-between">
        <div class="w-50 text-container" v-if="isExplanation1()">
          <p class="text">
            Le plus facile pour se repérer, c’est de choisir des éléments qui ressortent bien du paysage, des montagnes,
            des cours d’eau, des îles, etc. Ici, j’en ai choisi deux sortes différentes dans le paysage que nous
            apercevons au loin :
          </p>
          <ul>
            <li>
              <p class="text">
                Un cours d’eau. Tu le vois bien dans le paysage, et c’est forcément noté sur la carte avec la couleur
                bleue. Plus le trait bleu est épais, plus le cours d’eau est important. Si au contraire le trait est
                très fin voire même il est en pointillé, c’est un cours d’eau moins important.
              </p>
            </li>
            <li>
              <p class="text">
                Des montagnes. Évidemment qu’on les distingue bien, elles ressortent beaucoup sur l’horizon ! Et sur la
                carte, elles sont représentées par les courbes de niveau, ces lignes marron concentriques. Plus les
                courbes sont espacées, plus c’est plat ; plus elles sont rapprochées (parfois jusqu’à donner
                l’impression d’un trait marron épais), plus la pente est raide et plus ça grimpe.
              </p>
            </li>
          </ul>
          <p class="text">
            J’ai sélectionné plusieurs points du paysage que l’on voit bien depuis notre ballon, tu les vois en dessous
            de la carte. C’est à partir de ce paysage là qu’on va se repérer sur la carte.
          </p>
          <div class="w-100 text-center">
            <button type="submit" class="button" @click="validStep">Poursuivre les explications</button>
          </div>
        </div>

        <!-- Explication 2  -->
        <div class="w-50" v-if="isExplanation2()">
          <p class="text">
            Comme tu as pu le voir, le sommet le plus à gauche correspond au <i>Shiva’s Temple</i>. C’est le point le
            plus haut du paysage, on ne peut pas le louper. Il a des pentes très raides et est tout plat en haut, donc
            des courbes de niveau très resserrées puis plus aucune. Il a aussi de la végétation à son sommet que l’on
            retrouve par la couleur verte sur la carte.
            <br />
            <br />
            Les deux sommets suivants, ce sont le <i>Osiris Temple</i> et le <i>Tower of Ra</i>. Les courbes de niveau
            sont très rapprochées, presque comme un trait marron très épais sur la carte. Elles te donnent l’indication
            que les pentes sont très raides, presque verticales.
            <br />
            <br />
            Ensuite, tu vois un ruisseau qui vient de la gauche et se jette dans une rivière, presque à angle droit.
            C’est un endroit, pas loin de <i>Scylla Butte</i>, tu vois ? Le dernier sommet que l’on aperçoit le plus à
            droite, c’est le <i>Marsh Butte</i>.
            <br />
            <br />
            Et pour finir, la tente que tu aperçois au milieu, c’est un refuge qui est noté sur ta carte par un petit
            symbole noir.
          </p>
          <div class="w-100 text-center">
            <button type="submit" class="button" @click="validStep">Poursuivre les explications</button>
          </div>
        </div>

        <!-- lecture Payasage -->
        <div class="w-50" v-if="isLecture()">
          <p class="text">
            {{ text[currentStep] }}
          </p>
          <div class="my-3">
            <div class="d-flex justify-content-around" v-if="location[currentStep]">
              <div>
                <label for="A" class="font-weight-bold">A</label><br />
                <input type="radio" name="first" id="A" value="A" v-model="answer" />
              </div>
              <div>
                <label for="B" class="font-weight-bold">B</label><br />
                <input type="radio" name="first" id="B" value="B" v-model="answer" />
              </div>
              <div>
                <label for="C" class="font-weight-bold">C</label><br />
                <input type="radio" name="first" id="C" value="C" v-model="answer" />
              </div>
            </div>
            <div class="d-flex justify-content-around" v-else>
              <div>
                <label for="zero" class="font-weight-bold">0°</label><br />
                <input type="radio" name="second" id="zero" value="0" v-model="answer" />
              </div>
              <div>
                <label for="quarante" class="font-weight-bold">45°</label><br />
                <input type="radio" name="second" id="quarante" value="45" v-model="answer" />
              </div>
              <div>
                <label for="cent" class="font-weight-bold">135°</label><br />
                <input type="radio" name="second" id="cent" value="135" v-model="answer" />
              </div>
              <div>
                <label for="deuxcent" class="font-weight-bold">270°</label><br />
                <input type="radio" name="second" id="deuxcent" value="270" v-model="answer" />
              </div>
            </div>
          </div>

          <div class="w-100 text-center">
            <button type="submit" class="button" @click="validStep">Valider</button>
            <br />
            <span class="text-danger" v-show="wrongAnswer">Mmh... Observe un peu mieux !</span>
          </div>
        </div>
        <div class="w-50">
          <img :src="paysages[paysageByStep[currentStep]].carte" class="w-100 h-auto" />
        </div>
      </div>
      <div class="bot">
        <img
          src="https://cdn.exploreve.fr/content/IM3/images/paysage_carte/Boussole.svg"
          class="boussole"
          v-if="isOrientation()"
        />
        <div class="img-relief-container">
          <img :src="paysages[paysageByStep[currentStep]].paysage" :class="'relief-' + paysageByStep[currentStep]" />
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

const Paysage = {
  HIDE: -1,
  DESERT_EXPLANATION: 0,
  DESERT_EXPLANATION_WITH_CIRCLES: 1,
  DESERT: 2,
  JUNGLE: 3
};

const Step = {
  hide: -1,
  leonStart: 0,
  explanation1: 1,
  explanation2: 2,
  locationDesert: 3,
  orientationDesert: 4,
  locationJungle: 5,
  orientationJungle: 6,
  leonEnd: 7
};

export default {
  data() {
    return {
      goodAnswers: {
        [Step.locationDesert]: "C",
        [Step.orientationDesert]: "135",
        [Step.locationJungle]: "A",
        [Step.orientationJungle]: "270"
      },
      currentStep: -1,
      location: {
        [Step.locationDesert]: true,
        [Step.orientationDesert]: false,
        [Step.locationJungle]: true,
        [Step.orientationJungle]: false
      },
      answer: null,
      wrongAnswer: false,
      paysageByStep: {
        [Step.hide]: Paysage.HIDE,
        [Step.leonStart]: Paysage.HIDE,
        [Step.explanation1]: Paysage.DESERT_EXPLANATION,
        [Step.explanation2]: Paysage.DESERT_EXPLANATION_WITH_CIRCLES,
        [Step.locationDesert]: Paysage.DESERT,
        [Step.orientationDesert]: Paysage.DESERT,
        [Step.locationJungle]: Paysage.JUNGLE,
        [Step.orientationJungle]: Paysage.JUNGLE,
        [Step.leonEnd]: Paysage.HIDE
      },
      text: {
        [Step.leonStart]: `
          Quand on voyage en ballon-songe, la meilleure manière de se repérer pour savoir où on se trouve et déterminer la direction à suivre, c’est d’observer le paysage et de le comparer à notre carte. Cette technique est appelée la lecture paysage-carte. C’est un peu délicat, mais je sais que tu es un·e explorêveur·euse doué·e !

          Pour faire cet exercice, tu as besoin de trouver devant toi 3 points remarquables du paysages qui te serviront de repères. Ensuite, tu devras les reconnaître leur position sur la carte. Fonction de l’angle avec lequel tu aperçois ces 3 points, et de leur position relative les uns par rapport aux autres, tu peux déterminer ta propre position. A partir de là, trouver la direction à suivre c’est très facile.

          C’est un peu flou ? Pas de panique, on va faire un exemple ensemble. Ca sera plus facile avec un peu de pratique !
        `,
        [Step.locationDesert]: `
          Maintenant que tu as trouvé ces différents points de repère sur la carte, saurais-tu me dire d’où nous les observons ?

          Pour t’aider, je t’ai fait 3 propositions : A, B et C. Il y a un seul et unique endroit d’où tu peux observer les 3 points du paysage exactement dans cette disposition. A ton avis ?

          Réfléchis bien !
          Rappelle-toi, le Shiva’s Temple au premier plan, il est devant le Osiris Temple et le Tower of Ra. Le cours d’eau est plus loin en arrière-plan, sur ta droite, devant le Marsh Butte.
        `,
        [Step.orientationDesert]: `
          Bravo ! C’est bien du point C que nous observons ce superbe paysage, il n’y a que de là que les repères sont dans le bon ordre.

          Maintenant que nous connaissons notre position, il ne reste plus qu’à déterminer l’azimut à suivre pour aller dans la bonne direction, indiquée par la flèche bleue sur la carte.

          Quel est le cap à suivre ?
        `,
        [Step.locationJungle]: `
          Maintenant, à ton tour !

          Voilà une nouvelle carte, dans un autre environnement. Qui sait, peut-être notre voyage nous emmènera dans la forêt ?
          Je t’ai représenté quelques points que tu devrais facilement retrouver sur la carte.

          A ton avis, d’où observes-tu cette forêt ?
        `,
        [Step.orientationJungle]: `
          Tu as raison, nous sommes bien sur le point A.

          Et maintenant, quel azimut pour aller dans la direction de la flèche bleue ?
        `,
        [Step.leonEnd]: `
          Félicitations, la lecture paysage-carte n’a plus de secret pour toi ! Je sais que où que tu sois, tu sauras te repérer grâce au paysage et tu ne perdras jamais ton chemin. Je suis fier de toi !

          Pour finir ton apprentissage, je te rends les manettes du ballon-songe, continue ton voyage à travers la Troposphère pour te familiariser avec les commandes.
        `
      },
      buttonText: {
        [Step.leonStart]: "Poursuivre les explications",
        [Step.leonEnd]: "Reprendre le vol"
      },
      paysages: {
        [Paysage.HIDE]: {
          carte: null,
          paysage: null
        },
        [Paysage.DESERT_EXPLANATION]: {
          carte: "https://cdn.exploreve.fr/content/IM3/images/paysage_carte/carte_desert_vierge.png",
          paysage: "https://cdn.exploreve.fr/content/IM3/images/paysage_carte/paysage_carte_desert_v2.svg"
        },
        [Paysage.DESERT_EXPLANATION_WITH_CIRCLES]: {
          carte: "https://cdn.exploreve.fr/content/IM3/images/paysage_carte/carte_desert_vierge_cercl%C3%A9e.png",
          paysage: "https://cdn.exploreve.fr/content/IM3/images/paysage_carte/paysage_carte_desert_v2.svg"
        },
        [Paysage.DESERT]: {
          carte: "https://cdn.exploreve.fr/content/IM3/images/paysage_carte/carte_desert.png",
          paysage: "https://cdn.exploreve.fr/content/IM3/images/paysage_carte/paysage_carte_desert_v2.svg"
        },
        [Paysage.JUNGLE]: {
          carte: "https://cdn.exploreve.fr/content/IM3/images/paysage_carte/carte_jungle.png",
          paysage: "https://cdn.exploreve.fr/content/IM3/images/paysage_carte/paysage_carte_jungle.svg"
        }
      }
    };
  },
  methods: {
    showLeon() {
      return [Step.leonStart, Step.leonEnd].includes(this.currentStep);
    },
    isExplanation1() {
      return this.currentStep === Step.explanation1;
    },
    isExplanation2() {
      return this.currentStep === Step.explanation2;
    },
    isLecture() {
      return [Step.locationDesert, Step.orientationDesert, Step.locationJungle, Step.orientationJungle].includes(
        this.currentStep
      );
    },
    isOrientation() {
      return [Step.orientationDesert, Step.orientationJungle].includes(this.currentStep);
    },

    validStep() {
      if (this.currentStep === Step.leonStart) {
        this.next();
        this.$refs.modal.show();
        return;
      }
      if ([Step.explanation1, Step.explanation2].includes(this.currentStep)) {
        this.next();
        return;
      }
      if (
        [Step.locationDesert, Step.orientationDesert, Step.locationJungle, Step.orientationJungle].includes(
          this.currentStep
        )
      ) {
        if (this.answer === this.goodAnswers[this.currentStep]) {
          if (this.currentStep === Step.orientationJungle) {
            this.$refs.modal.hide();
          }
          this.next();
          return;
        } else {
          this.wrongAnswer = true;
        }
      }
      if (this.currentStep === Step.leonEnd) {
        this.currentStep = Step.hide;
        this.$store.dispatch("changeState", "PLAY");
        return;
      }
    },
    next() {
      if (this.currentStep !== Step.leonEnd) {
        this.currentStep++;
        this.answer = null;
        this.wrongAnswer = false;
      }
    }
  },
  computed: {
    ...mapGetters(["game_state"], "game_state")
  },
  watch: {
    game_state: function (value) {
      if (value === "LECTURE") {
        this.currentStep = Step.leonStart;
        this.wrongAnswer = false;
        this.answer = null;
        this.$emit("audio", { action: "play", id: "music04" });
      }
    }
  }
};
</script>
<style scoped lang="scss">
.close {
  display: none;
}
.button {
  font-family: Faune;
  font-style: normal;
  font-weight: normal;

  background: #5e2a57;
  border-radius: 5px;
  color: white;
  padding: 12px 18px;
}
h3 {
  font-family: Faune;
  font-style: normal;
  font-weight: normal;
}
.text-container {
  z-index: 100;
}
.text {
  margin: 5px 15px;
  text-align: justify;
  font-family: Faune;
  font-style: normal;
  font-weight: normal;
  white-space: pre-line;
}
input[type="radio"] {
  margin-top: -1px;
  vertical-align: middle;
}
.bot {
  height: 150px; //200px
}
.boussole {
  position: absolute;
  bottom: 4vh;
  left: 5vh;
  height: 30%;
  width: auto;
}
.img-relief-container {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 26%; //40%
  overflow: hidden;
}
.relief-0 {
  transform: translateY(-28%) scale(0.5);
}
.relief-1 {
  transform: translateY(-28%) scale(0.5);
}
.relief-2 {
  transform: translateY(-28%) scale(0.5);
}
.relief-3 {
  transform: translateY(-32%) scale(0.3);
}

.bulle {
  position: absolute;
  margin: 10px;
  background-color: white;
  max-width: 60vh;
  height: auto;
  border-radius: 20px;
  text-align: left;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  z-index: 201;
}

.bulle::after {
  content: "";
  position: absolute;
  left: -40px;
  top: 30%;
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 40px solid white;
}

.leon {
  img {
    height: 60vh;
  }
  position: absolute;
  top: 25vh;
  left: 20vw;
  z-index: 201;
}

.back {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.53);
  z-index: 100;
}
.next-button {
  position: absolute;
  font-family: "faune";
  font-size: 24px;
  padding: 5px 50px;
  background-color: #5e2a57;
  color: white !important;
  text-decoration: none !important;
  border-radius: 5px;
  cursor: pointer;
  z-index: 201;
}
</style>
